export default "__VITE_ASSET__D9WAq570__"